import { ExperimentDesignSummary } from '@mightyhive/commoncomponents';
import { apiFetch } from '../../utils/api';
import type { LibraryDesignProgress } from '../../utils/libraryTypes';

interface LibraryDesignTabProps {
  externalUuid: string;
  design: LibraryDesignProgress;
  editDesignUrl?: string | null;
  onEditDesign?: () => void;
}

export function LibraryDesignTab({
  externalUuid,
  design,
  editDesignUrl,
  onEditDesign,
}: LibraryDesignTabProps): JSX.Element {
  return (
    <ExperimentDesignSummary
      analysisId={externalUuid}
      apiFetch={apiFetch}
      design={design}
      editDesignUrl={editDesignUrl}
      onEditDesign={onEditDesign}
    />
  );
}
